import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import Exercise from '../aggregates/exercise/Exercise';
import Lesson from '../aggregates/lesson/Lesson';
import ExerciseTemplate from '../aggregates/exerciseTemplate/ExerciseTemplate';

export default class ExerciseRepository extends Repository<Exercise> {

	public mapObject (data: ApiData) {
		return new Exercise(
			data.id<Exercise>('id'),
			data.id<Lesson>('lessonId'),
			data.string('content'),
			data.id<ExerciseTemplate>('templateId'),
			data.map('contents', data => data.string())
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/ExerciseRepository.ts